import { useEffect, useState } from "react";
import { collection, orderBy, query, where, doc } from "firebase/firestore";
import { useCollection } from "react-firebase-hooks/firestore";
import { db } from "@poseidon/firebase/firebase";

export const useFiles = ({
  fileCategory,
  fileGroup,
  applicationId,
  agreementId,
  sailorId,
  dealerId,
}) => {
  const [files, setFiles] = useState([]);

  if (fileCategory === "sailor" && !sailorId) {
    throw Error(
      "No sailorId supplied to useFiles when fileCategory === sailor"
    );
  }

  if (fileCategory === "application" && !applicationId) {
    throw Error(
      "No applicationId supplied to useFiles when fileCategory === application"
    );
  }

  if (fileCategory === "agreement" && !agreementId) {
    throw Error(
      "No agreementId supplied to useFiles when fileCategory === agreement"
    );
  }

  if (fileCategory === "dealer" && !dealerId) {
    throw Error(
      "No dealerId supplied to useFiles when fileCategory === dealer"
    );
  }

  const [value, loading, error] = useCollection(
    query(
      collection(db, "files"),
      where("fileCategory", "==", fileCategory),
      where("fileGroup", "==", fileGroup),
      ...(fileCategory === "sailor"
        ? [where("sailor", "==", doc(db, "sailors", sailorId))]
        : []),
      ...(fileCategory === "application"
        ? [where("application", "==", doc(db, "applications", applicationId))]
        : []),
      ...(fileCategory === "agreement"
        ? [where("agreement", "==", doc(db, "agreements", agreementId))]
        : []),
      ...(fileCategory === "dealer"
        ? [where("dealer", "==", doc(db, "dealers", dealerId))]
        : []),
      orderBy("createdAt", "desc")
    )
  );

  useEffect(() => {
    if (value) {
      const docs = value.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setFiles(docs);
    }
  }, [value, fileCategory]);

  return { files, loading, error };
};
